<template>
  <div class="footer">
    <div class="content">
      <div class="content_left">
        <div class="link_wrap">
          <div class="link_title">友情链接</div>
          <ul class="link_item" >
              <li v-for="(item,index) in links" :key="index" @click="goLink(item.msg.url)">
                {{item.msg.name}}
              </li>
          </ul>
          
          <!-- <div class="link_item">北京市教委</div>
          <div class="link_item">银川市教委</div>
          <div class="link_item">银川市教科所</div>
          <div class="link_item">首都师范大学</div>
          <div class="link_item">书香中国</div>
          <div class="link_item" style="border-right:none">乐智悦读</div> -->
        </div>
        <div class="info_wrap flex-layout">
          <div class="info_left">联系我们:</div>
          <div class="info_right flex-column">
            <div class="info_us">{{team}}</div>
            <div class="flex-align info_item">
              <img src="@/assets/img/footer/phone.png" />
              <span>{{phone}}</span>
            </div>
            <div class="flex-align info_item">
              <img src="@/assets/img/footer/email.png" />
              <span>E-mail:{{email}}</span>
            </div>
            <div class="flex-align info_item">
              <img src="@/assets/img/footer/address.png" />
              <span>联系地址:{{address}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="content_right">
        <!-- <div class="qrcode qrcode1">
          <img src="@/assets/img/footer/qrcode1.png" />
          <span>双优云桥</span>
        </div> -->
        <div class="qrcode">
          <img src="@/assets/img/footer/qrcode2.png" />
          <span>首都教育远程互助工程</span>
        </div>
      </div>
    </div>
    <div class="records_wrap flex-align-center">
        <!-- <div>COPYRIGHT@2022首都师范大学“双优云桥”项目组 </div> -->
        <div class="support">“双优云桥”项目组 </div>
        <!-- <div class="support">技术支持:首都师范大学"双优云桥"项目组</div> -->
        <div>京ICP备17019635号-3</div>
    </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            team:'“双优云桥”项目组',
            phone:'010-88512948',
            email:'yd@lezhireading.com',
            address:'北京市海淀区西三环北路105号科原大厦B座',
            links:[],
        }
    },
    methods:{
      async getLinks() {
        let resData = await Api.About.getLinks()
        // console.log(resData)
        this.links = resData.data
      },
      goLink(url){
        if(!url) return
        window.open(url)
      }
    },
    mounted(){
      this.getLinks();
    }
};
</script>

<style lang="less">
@import "./less/footer.less";
</style>